/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_DescriptionInputs */

const en_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Description`)
};

const es_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción pública`)
};

const fr_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description publique`)
};

const de_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffentliche Beschreibung`)
};

const ja_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開される説明`)
};

const zh_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开描述`)
};

const ar_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصف العام`)
};

const id_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deskripsi Publik`)
};

const it_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione Pubblica`)
};

const ru_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публичное описание`)
};

const pt_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição Pública`)
};

const ko_public_description = /** @type {(inputs: Public_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공개 설명`)
};

/**
* | output |
* | --- |
* | "Public Description" |
*
* @param {Public_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const public_description = /** @type {((inputs?: Public_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_description(inputs)
	if (locale === "es") return es_public_description(inputs)
	if (locale === "fr") return fr_public_description(inputs)
	if (locale === "de") return de_public_description(inputs)
	if (locale === "ja") return ja_public_description(inputs)
	if (locale === "zh") return zh_public_description(inputs)
	if (locale === "ar") return ar_public_description(inputs)
	if (locale === "id") return id_public_description(inputs)
	if (locale === "it") return it_public_description(inputs)
	if (locale === "ru") return ru_public_description(inputs)
	if (locale === "pt") return pt_public_description(inputs)
	return ko_public_description(inputs)
});